(() => {
  const app = angular.module('app');
  app.controller('host.views.clinics.index', ClinicsListingPageController);

  ClinicsListingPageController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$uibModal',
    '$timeout',
    'abp.services.app.clinic',
    'abp.services.app.commonLookup',
    'lookupModal',
    'countries',
    'Hms.MultiTenancy.TenantClinicType',
    'authentication',
    'Hms.Finance.TransactionTenantType',
  ];

  function ClinicsListingPageController(
    $scope,
    $state,
    $stateParams,
    $uibModal,
    $timeout,
    clinicSvc,
    commonLookupSvc,
    lookupModal,
    countries,
    enumTenantClinicType,
    authentication,
    enumTransactionTenantType
  ) {
    const vm = this;
    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.loading = 0;
    vm.filterText = $stateParams.filterText || '';
    vm.clinicType = $stateParams.clinicType || '';
    vm.exporting = 0;
    vm.hasSingaporeInvoiceGeneration = abp.setting.getBoolean(
      'Hms.Feature.SingaporeInvoiceGeneration'
    );

    // Check for inpatient module enable for the application.

    vm.applicationHasInpatientModule = abp.setting.getBoolean('Hms.Feature.InpatientModule');

    vm.hasRegionalSystemSupport = abp.setting.getBoolean('Hms.Feature.RegionalSystemSupport');

    vm.enums = {};
    vm.enums.tenantClinicType = enumTenantClinicType;
    vm.enums.transactionTenantType = enumTransactionTenantType;
    vm.createManualTransactionRequest = createManualTransactionRequest;

    $scope.$on('$viewContentLoaded', () => {
      App.initAjax();
    });

    // Assign permissions

    vm.permissions = {
      create: abp.auth.isGranted('Host.Clinics.Create'),
      createOverride: abp.auth.isGranted('Host.Clinics.CreateOverride'),
      edit: abp.auth.isGranted('Host.Clinics.Edit'),
      changeTreatmentRates: abp.auth.isGranted('Host.Clinics.ChangeTreatmentRates'),
      delete: abp.auth.isGranted('Host.Clinics.Delete'),
      saleTransactions: abp.auth.isGranted('SaleTransactions'),
      generateSaleTransactions: abp.auth.isGranted('Host.Clinics.GenerateSaleTransactions'),
      patientTickets: abp.auth.isGranted('PatientTickets'),
      impersonation: abp.auth.isGranted('Host.Clinics.Impersonation'),
      viewLocations: abp.auth.isGranted('Host.Clinics.Locations'),
      resetAdminPassword: abp.auth.isGranted('Host.Clinics.ResetAdminPassword'),
      licensingFee: abp.auth.isGranted('Host.Clinics.LicensingFees'),
      createManualTransaction: abp.auth.isGranted(
        'HealthMetrics.Finance.ManualTransactionRequests.Create'
      ),
    };
    vm.permissions.resetAdminPassword ||= vm.permissions.edit;

    const zendeskSubdomain = abp.setting.get('Hms.Integration.Zendesk.Subdomain');
    vm.hasZendeskIntegration = zendeskSubdomain && zendeskSubdomain !== '';

    // Define grid options

    const viewOptions = {
      skipCount: $stateParams.skipCount || 0,
      maxResultCount: $stateParams.maxResultCount || app.consts.grid.defaultPageSize,
      sorting: $stateParams.sorting,
    };

    vm.clinicGridOptions = {
      appScopeProvider: vm,
      paginationPageSizes: app.consts.grid.defaultPageSizes,
      paginationPageSize: app.consts.grid.defaultPageSize,
      paginationCurrentPage: 0,
      useExternalPagination: true,
      useExternalSorting: true,
      enableRowSelection: true,
      enableSelectAll: false,
      enableFullRowSelect: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      rowTemplate:
        '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader, \'text-muted\': !row.entity.isActive }"  ui-grid-cell></div>',
      columnDefs: [
        {
          name: App.localize('Actions'),
          enableSorting: false,
          width: 100,
          headerCellTemplate: '<span></span>',
          cellTemplate: 'actionTemplate',
          allowCellFocus: false,
        },
        {
          displayName: App.localize('Warning'),
          enableSorting: false,
          field: 'warnings',
          width: 25,
          cellTemplate: 'warningsTemplate',
        },
        {
          displayName: App.localize('Country'),
          field: 'accountOwnerCountryName',
          width: 30,
          visible: vm.hasRegionalSystemSupport,
          cellTemplate: 'countryTemplate',
        },
        {
          displayName: App.localize('PanelCode'),
          field: 'tenancyName',
          minWidth: 120,
        },
        {
          displayName: App.localize('Type'),
          field: 'clinicType',
          cellTemplate: 'clinicTypeTemplate',
          width: 50,
        },
        {
          displayName: App.localize('Services'),
          field: 'services',
          visible: vm.applicationHasInpatientModule,
          cellTemplate: 'serviceTemplate',
          width: 100,
        },
        {
          displayName: App.localize('PanelCompanyName'),
          field: 'name',
          minWidth: 120,
        },
        {
          displayName: App.localize('ContactNumber'),
          field: 'contactNumber',
          minWidth: 100,
        },
        {
          displayName: App.localize('UnbilledAmount'),
          field: 'unbilledAmount',
          cellFilter: 'currencyFormat: row.entity.currencyCode',
          enableSorting: false,
          minWidth: 100,
        },
        {
          displayName: App.localize('IsActive'),
          field: 'isActive',
          cellTemplate: 'activeTemplate',
          minWidth: 65,
        },
        {
          displayName: App.localize('StartDate'),
          field: 'startDate',
          cellTemplate: 'startDateTemplate',
          minWidth: 100,
        },
        {
          displayName: App.localize('CreationDate'),
          field: 'creationTime',
          cellFilter: "momentFormat: 'L'",
          minWidth: 100,
        },
        {
          displayName: App.localize('Remarks'),
          field: 'remarks',
          minWidth: 100,
        },
      ],
      onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, (scope, callback) => {
          let sorting = '';
          for (let i = 0; i < callback.length; i += 1) {
            if (i) sorting += ', ';
            sorting += `${callback[i].field} ${callback[i].sort.direction}`;
          }
          viewOptions.sorting = sorting;
          vm.getClinics();
        });
        gridApi.pagination.on.paginationChanged(
          $scope,
          App.setPagination(viewOptions, vm.getClinics)
        );
        gridApi.selection.on.rowSelectionChanged($scope, (row) => {
          if (vm.permissions.viewLocations) {
            if (row.isSelected) {
              $state.go('host.clinics.locations', {
                id: row.entity.id,
              });
              vm.gridSelectedId = row.entity.id;
            } else {
              $state.go('host.clinics');
              vm.gridSelectedId = null;
            }
          }
        });
      },
      data: [],
    };
    vm.gridSelectedId = parseInt($stateParams.id, 10) || null;

    vm.getDateString = getDateString;

    // Define functions

    function registerStateParams() {
      $state.transitionTo(
        $state.current,
        {
          skipCount: viewOptions.skipCount,
          maxResultCount: viewOptions.maxResultCount,
          sorting: viewOptions.sorting,
          filterText: vm.filterText,
          clinicType: vm.clinicType,
          country: vm.countryCode,
          id: $stateParams.id,
        },
        {
          notify: false,
        }
      );
    }

    function getRequestInput() {
      registerStateParams();

      return {
        skipCount: viewOptions.skipCount,
        maxResultCount: viewOptions.maxResultCount,
        sorting: viewOptions.sorting,
        filter: vm.filterText,
        clinicType: vm.clinicType,
        countryCode: vm.countryCode,
      };
    }

    vm.getClinics = () => {
      const input = getRequestInput();

      vm.loading += 1;
      clinicSvc
        .getClinics(input)
        .success((data) => {
          _.forEach(data.items, (d) => {
            d.canChangeRates = vm.permissions.changeTreatmentRates;

            const country = _.find(countries, ['code', d.accountOwnerCountryCode]);

            d.currencyCode = country.currencyCode;
          });

          vm.clinicGridOptions.totalItems = data.totalCount;
          vm.clinicGridOptions.data = data.items;

          $scope.gridApi.grid.modifyRows(vm.clinicGridOptions.data);
          if (vm.gridSelectedId) {
            for (let i = vm.clinicGridOptions.data.length - 1; i >= 0; i -= 1) {
              if (vm.clinicGridOptions.data[i].id === vm.gridSelectedId) {
                $scope.gridApi.selection.selectRow(vm.clinicGridOptions.data[i]);
                break;
              }
            }
          }
        })
        .finally(() => {
          vm.loading -= 1;
        });
    };

    vm.manageLocations = (clinic) => {
      $state.go('host.clinics.locations', {
        id: clinic.id,
      });
    };

    vm.resetAdminPassword = (clinic) => {
      $uibModal.open({
        templateUrl: require('./resetAdminPassword/resetAdminPassword.modal.html'),
        controller: 'host.views.clinics.resetAdminPasswordModel as vm',
        backdrop: 'static',
        resolve: {
          tenancyName() {
            return clinic.tenancyName;
          },
          panelId() {
            return clinic.id;
          },
        },
      });
    };

    vm.unlockAdminUser = (panel) => {
      clinicSvc
        .unlockAdminUser({
          id: panel.id,
        })
        .success(() => {
          abp.notify.success(App.localize('UserSuccessfullyUnlocked'));
        });
    };

    vm.editTreatmentRates = (clinic) => {
      $uibModal.open({
        templateUrl: require('./ratesModal.html'),
        controller: 'host.views.clinics.ratesModal as vm',
        backdrop: 'static',
        resolve: {
          clinic() {
            return clinic;
          },
        },
      });
    };

    vm.deletePanel = (clinic) => {
      abp.message.confirm(
        App.localize('PanelDeleteWarningMessage', clinic.tenancyName),
        App.localize('AreYouSure'),
        (result) => {
          if (result) {
            clinicSvc
              .deletePanel({
                id: clinic.id,
              })
              .success(() => {
                vm.getClinics();
                abp.notify.success(App.localize('SuccessfullyDeleted'));
              });
          }
        }
      );
    };

    vm.impersonate = (clinic) => {
      lookupModal.open({
        title: App.localize('SelectAUser'),
        serviceMethod: commonLookupSvc.findUsersWithIdentityServerId,
        extraFilters: {
          tenantId: clinic.id,
        },
        callback(user) {
          authentication.impersonate(user.value, user.targetTenantId);
        },
      });
    };

    vm.generateStatement = (clinic) => {
      const modal = $uibModal.open({
        templateUrl: require('../../../common/views/saleTransactions/createStatementModal.html'),
        controller: 'common.views.saleTransactions.createStatementModal as vm',
        backdrop: 'static',
        resolve: {
          tenantId() {
            return clinic.id;
          },
          subsidiaryId: null,
        },
      });
      modal.result.then((input) => {
        $state.go('statement', input);
      });
    };

    vm.generateSaleTransactions = (clinic) => {
      abp.message.confirm(
        App.localize('GenerateSaleTransactionsWarningMessage', clinic.tenancyName),
        App.localize('AreYouSure'),
        (result) => {
          if (result) {
            clinicSvc
              .generateSaleTransactions({
                id: clinic.id,
              })
              .success(() => {
                vm.getClinics();
                abp.notify.success(App.localize('SaleTransactionsGenerated'));
              });
          }
        }
      );
    };

    vm.initializeZendeskOrganization = (clinic) => {
      abp.message.confirm(
        App.localize('InitializeZendeskOrganizationWarningMessage', clinic.tenancyName),
        App.localize('AreYouSure'),
        (result) => {
          if (result) {
            clinicSvc
              .initializeZendeskOrganization({
                id: clinic.id,
              })
              .success(() => {
                vm.getClinics();
                abp.notify.success(App.localize('InitializeZendeskOrganizationRequestSent'));
              });
          }
        }
      );
    };

    vm.exportToExcel = () => {
      const input = getRequestInput();

      vm.exporting += 1;
      clinicSvc
        .getClinicsToExcel(input)
        .success((data) => {
          App.downloadTempFile(data);
        })
        .finally(() => {
          vm.exporting -= 1;
        });
    };

    vm.isAllowedForInvoiceGeneration = (clinic) =>
      vm.hasSingaporeInvoiceGeneration || clinic.accountOwnerCountryCode !== 'SG';

    function createManualTransactionRequest(clinic) {
      $state.go('finance.createEditManualTransactionRequest', {
        isCreate: true,
        tenancyName: clinic.tenancyName,
        transactionTenantType: vm.enums.transactionTenantType.Panel.id,
      });
    }

    function getDateString(date) {
      return App.getDateString(moment.utc(date));
    }

    init();

    function init() {
      $timeout(() => {
        vm.clinicGridOptions.paginationCurrentPage = Math.floor(
          viewOptions.skipCount / viewOptions.maxResultCount + 1
        );
      });

      if (vm.hasRegionalSystemSupport) {
        vm.loading += 1;
        commonLookupSvc
          .getEligibleCountries()
          .success((data) => {
            const elligibleCountryCodes = data.map((o) => o.code);

            vm.countries = _.filter(countries, (c) => elligibleCountryCodes.includes(c.code));
          })
          .finally(() => {
            vm.loading -= 1;
          });
      }
    }
  }
})();
